import * as h2Api from '../../h2Api'

export const LIST_GAMES = 'EARLY_GAME_LISTING'
export const LOAD_GAME = 'EARLY_GAME_LOAD'
export const CREATE_GAME = 'EARLY_CREATE_GAME'
export const TOGGLE_LOADING = 'EARLY_GAME_TOGGLE_LOADING'

export const listGames = () => {
  return h2Api.get('/early/list')({ type: LIST_GAMES })
}

export const loadGame = gameId => {
  return h2Api.get(`/api/v2/early/utl/${gameId}`)({ type: LOAD_GAME })
}

export const setDataLoaded = st => dispatch =>
  dispatch({ type: TOGGLE_LOADING, dataLoaded: st })

export const createGame = () => {
  return h2Api.post('/api/v2/early/utl', {})({ type: CREATE_GAME })
}
